module.exports = __webpack_public_path__ + "img/Imagen 5.848d29a9.jpg";